import React from 'react'
import {
    Pagination
} from '@material-ui/core'
import { useParams } from '../../utils/Hooks'
import { updateQueryParams } from '../../utils/UrlManipulation'

const PaginationControls = ({ loading, totalResults }) => {
    const { page, page_size } = useParams()
    const totalPages = Math.ceil(totalResults / page_size) || 1

    const updatePage = React.useCallback(newPage => {
        updateQueryParams({ page: newPage })
    }, [])

    const handleChange = (event, newPage) => {
        updatePage(newPage)
        window.scrollTo(0, 0)
    }

    if (loading) return null

    return (
        <Pagination color="primary" count={totalPages} page={page} onChange={handleChange} />
    )
}

export default PaginationControls